export type Theme = 'light' | 'dark'
export const themes: Array<Theme> = ['light', 'dark']
